import zh from './locales/zh'
import en from './locales/en'

export interface LocaleRegistration {
  code: string
  nativeName: string
  translation: Record<string, unknown>
}

export const localeRegistry = [
  { code: 'zh', nativeName: '中文', translation: zh },
  { code: 'en', nativeName: 'English', translation: en },
] as const satisfies readonly LocaleRegistration[]

export type RegisteredLocaleCode = (typeof localeRegistry)[number]['code']

export const localeCodes = localeRegistry.map((locale) => locale.code)

export function isRegisteredLocale(code: string | null | undefined): code is RegisteredLocaleCode {
  return typeof code === 'string' && localeCodes.includes(code as RegisteredLocaleCode)
}

export function getLocaleTranslation(code: RegisteredLocaleCode): Record<string, unknown> {
  return localeRegistry.find((locale) => locale.code === code)?.translation ?? {}
}
